var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thbfx',{attrs:{"type":_vm.type,"timeType":_vm.timeType,"treeAddress":'/analysis/hbfx/hbfx2'}})
}
var staticRenderFns = []

export { render, staticRenderFns }